var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.4375,
    y: 0.549805,
    width: 4.12502,
    height: 2.47475,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68184 5.79302H8.31937V6.92224H8.86937V5.20642H5.7756V4.0332H5.2256V5.20642H2.13184V6.92224H2.68184V5.79302Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12502 7.33398H0.687503C0.505166 7.33398 0.330297 7.41124 0.201365 7.54875C0.0724332 7.68626 0 7.87277 0 8.06724V10.267C0 10.4615 0.0724332 10.648 0.201365 10.7855C0.330297 10.923 0.505166 11.0003 0.687503 11.0003H4.12502C4.30736 11.0003 4.48223 10.923 4.61116 10.7855C4.74009 10.648 4.81252 10.4615 4.81252 10.267V8.06724C4.81252 7.87277 4.74009 7.68626 4.61116 7.54875C4.48223 7.41124 4.30736 7.33398 4.12502 7.33398ZM0.687503 10.267V8.06724H4.12502V10.267H0.687503Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 7.33398H6.875C6.69267 7.33398 6.5178 7.41124 6.38887 7.54875C6.25993 7.68626 6.1875 7.87277 6.1875 8.06724V10.267C6.1875 10.4615 6.25993 10.648 6.38887 10.7855C6.5178 10.923 6.69267 11.0003 6.875 11.0003H10.3125C10.4949 11.0003 10.6697 10.923 10.7987 10.7855C10.9276 10.648 11 10.4615 11 10.267V8.06724C11 7.87277 10.9276 7.68626 10.7987 7.54875C10.6697 7.41124 10.4949 7.33398 10.3125 7.33398ZM6.875 10.267V8.06724H10.3125V10.267H6.875Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 3.6663H7.21877C7.40111 3.6663 7.57598 3.58904 7.70491 3.45153C7.83384 3.31402 7.90627 3.12751 7.90627 2.93304V0.733259C7.90627 0.538787 7.83384 0.352279 7.70491 0.214767C7.57598 0.0772539 7.40111 0 7.21877 0H3.78125C3.59892 0 3.42405 0.0772539 3.29512 0.214767C3.16618 0.352279 3.09375 0.538787 3.09375 0.733259V2.93304C3.09375 3.12751 3.16618 3.31402 3.29512 3.45153C3.42405 3.58904 3.59892 3.6663 3.78125 3.6663ZM3.78125 0.733259H7.21877V2.93304H3.78125V0.733259Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/organisation.e4704908abe13dd08d0390e0fcd2f16e.svg";
export { ForwardRef as ReactComponent };